//Custom components
import StatCard from '../../../UI/Card/StatCard';

const BlightedPropertiesEliminatedWidget = ({ count }: { count: number }) => {
  return <StatCard title='Blighted Properties Eliminated' stat={count} />;
};

export default BlightedPropertiesEliminatedWidget;
